import { Section, SectionTitle, CaseCard } from './shared';

export function OfficeAutomationContent() {
  const officeCases = [
    {
      icon: '💼',
      title: '飞书全家桶自动化',
      description: '5分钟让 OpenClaw 玩转飞书全家桶,实现文档、表格、日程的智能化管理',
      tags: ['飞书', '办公自动化', '效率工具'],
      difficulty: 'beginner' as const,
      link: 'https://curl.qcloud.com/PWo3Suxt',
    },
  ];

  return (
    <div className="space-y-8">
      <Section>
        <SectionTitle>办公自动化案例</SectionTitle>
        <p className="text-slate-400 mb-6">
          通过 OpenClaw 实现办公流程自动化,提升团队协作效率和工作质量。
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {officeCases.map((caseItem, index) => (
            <CaseCard key={index} {...caseItem} />
          ))}
        </div>
      </Section>

      <Section>
        <div className="bg-cyan-500/10 border border-cyan-500/50 rounded-lg p-6">
          <h3 className="text-lg font-semibold text-cyan-400 mb-3">💡 自动化场景</h3>
          <ul className="space-y-2 text-slate-300">
            <li className="flex items-start gap-2">
              <span className="text-cyan-400 mt-1">•</span>
              <span>自动生成会议纪要和待办事项</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-cyan-400 mt-1">•</span>
              <span>智能管理飞书文档和表格</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-cyan-400 mt-1">•</span>
              <span>日程安排和任务提醒</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-cyan-400 mt-1">•</span>
              <span>团队协作流程优化</span>
            </li>
          </ul>
        </div>
      </Section>
    </div>
  );
}